module.exports = __webpack_public_path__ + "static/img/kids_cyberbullying.e60c8e03.png";